module.exports = __webpack_public_path__ + "static/media/christie-lose.41824315.png";